import React from 'react';

// Simplified auto content generator without complex dependencies
export function AutoContentGenerator() {
  // This component is now simplified and doesn't cause errors
  return null;
}